import React, { useMemo, useState, useEffect, useRef } from 'react';
import { useDashboard } from '../../context/DashboardContext';
import { useConfiguration } from '../../context/ConfigurationContext';
import ImpactCard from '../cards/ImpactCard';

const SummaryView = () => {
  const { currentCity, getOrderedImpacts } = useDashboard();
  const { isCityAvailable } = useConfiguration();
  const isDataAvailable = isCityAvailable(currentCity);
  const [expandedCards, setExpandedCards] = useState(new Set());
  const initializedRef = useRef(false);
  const [orderUpdateKey, setOrderUpdateKey] = useState(0);
  
  const orderedImpacts = useMemo(() => {
    return getOrderedImpacts(currentCity);
  }, [currentCity, getOrderedImpacts, orderUpdateKey]);
  
  // Listen for priority order changes
  useEffect(() => {
    const handlePriorityOrderChange = () => {
      setOrderUpdateKey(prev => prev + 1);
    };
    
    window.addEventListener('priorityOrderChanged', handlePriorityOrderChange);
    return () => {
      window.removeEventListener('priorityOrderChanged', handlePriorityOrderChange);
    };
  }, []);

  // Initialize: all cards expanded by default (only once per city change)
  useEffect(() => {
    if (orderedImpacts.length > 0 && !initializedRef.current) {
      setExpandedCards(new Set(orderedImpacts.map(impact => impact.id)));
      initializedRef.current = true;
    }
  }, [orderedImpacts]);

  // Reset initialization when city changes
  useEffect(() => {
    initializedRef.current = false;
  }, [currentCity]);

  const handleCardToggle = (impactId) => {
    setExpandedCards(prev => {
      const newSet = new Set(prev);
      if (newSet.has(impactId)) {
        newSet.delete(impactId);
      } else {
        newSet.add(impactId);
      }
      return newSet;
    });
  };

  return (
    <section id="view-summary">
      <div className="dashboard-header">
        <h2><span>{currentCity}</span> Heat Stress Summary</h2>
      </div>

      <div className="summary-layout" style={{ gridTemplateColumns: '1fr' }}>
        <div className="summary-grid">
          {orderedImpacts.map((impact, index) => {
            const rank = index + 1;
            return (
              <ImpactCard
                key={impact.id}
                impact={impact}
                city={currentCity}
                isDataAvailable={isDataAvailable}
                isExpanded={expandedCards.has(impact.id)}
                onToggle={() => handleCardToggle(impact.id)}
                rank={rank}
              />
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default SummaryView;

